
export function Services() {
  const services = [
    {
      icon: 'ri-film-fill',
      title: 'Overseas Video Production',
      description: 'Professional video shooting and production services across global markets, including brand films, product videos, and corporate documentaries with local cultural insights.',
      features: ['Brand Films', 'Product Videos', 'Corporate Documentaries', 'Social Media Content']
    },
    {
      icon: 'ri-live-fill',
      title: 'International Conference Media',
      description: 'Comprehensive media support for international conferences and events, including live streaming, multi-camera coverage, and real-time translation services.',
      features: ['Live Streaming', 'Multi-Camera Coverage', 'Event Recording', 'Real-time Translation']
    },
    {
      icon: 'ri-global-fill',
      title: 'Cross-Cultural Communication',
      description: 'Tailored content strategies for different markets, ensuring your message resonates with local audiences while maintaining brand consistency.',
      features: ['Market Localization', 'Multilingual Content', 'Cultural Adaptation', 'Brand Consistency']
    },
    {
      icon: 'ri-broadcast-fill',
      title: 'Overseas Live Broadcasting',
      description: 'Professional live broadcasting services for global events, product launches, and corporate communications with multi-platform distribution.',
      features: ['Multi-Platform Streaming', 'Interactive Features', 'Technical Support', 'Post-Event Analytics']
    },
    {
      icon: 'ri-movie-2-fill',
      title: 'Multilingual Promotional Videos',
      description: 'Create compelling promotional videos in multiple languages, optimized for different platforms and target audiences worldwide.',
      features: ['Script Writing', 'Voice-over Services', 'Subtitle Localization', 'Platform Optimization']
    },
    {
      icon: 'ri-team-fill',
      title: 'Brand Going Global Support',
      description: 'End-to-end media solutions for Chinese brands expanding overseas, from strategy planning to content production and distribution.',
      features: ['Market Research', 'Content Strategy', 'Production Management', 'Distribution Support']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-4">
            <span className="text-blue-600 font-semibold text-sm">OUR SERVICES</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Comprehensive <strong>Global Media Solutions</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From overseas video production to international conference media support, we provide professional services that help your brand succeed in global markets.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group hover:-translate-y-2"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-md">
                <i className={`${service.icon} text-white`} style={{ fontSize: '40px' }}></i>
              </div>
              
              <h4 className="text-2xl font-bold text-gray-900 mb-4">
                <strong>{service.title}</strong>
              </h4>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <div className="space-y-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <i className="ri-check-line text-blue-600 text-lg"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
